import { render, staticRenderFns } from "./edit-employee.vue?vue&type=template&id=4e37063c&scoped=true"
import script from "./edit-employee.vue?vue&type=script&lang=js"
export * from "./edit-employee.vue?vue&type=script&lang=js"
import style0 from "./edit-employee.vue?vue&type=style&index=0&id=4e37063c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e37063c",
  null
  
)

export default component.exports